/** @jsx jsx */
import React, { useEffect, useState } from 'react';

import SelectForm from 'components/molecules/SelectForm';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import FormLabel from 'components/atoms/Form/FormLabel';
import FlexBox from 'components/atoms/FlexBox';
import productColor, {
} from 'components/styles';
import DataTable from 'components/organismos/DataTable/DataTable';
import { css, jsx } from '@emotion/core';
import Accordion from 'components/molecules/Accordion';
import PaidHolidayDigestedtHistoryDomain from 'domain/master/holidayManagement/paidHolidayDigestedtHistory';
import { Column } from 'react-table';
import Modal from 'components/molecules/Modal';
import moment from 'moment';

import VerticalLabelTextLayout from 'components/atoms/Form/VerticalLabelTextLayout';
import { isSafari, isIPad13, isTablet } from 'react-device-detect';
import { useAcquisitionStatusDomainForm, useDownloadHolidayManagementAcquisitionStatus } from './hooks';
import IconLabelButton from 'components/molecules/IconLabelButton';
import CalendarForm from 'components/molecules/CalendarForm';
import BlockUI from 'components/molecules/BlockUi';
import FormPadding from 'components/atoms/Form/FormPadding';
import Calendar from 'components/molecules/CalendarV1';
import TextTooltip from 'components/molecules/TextTooltip';

// create style form
const styles = {
  form: css({
    paddingTop: '15px',
  }),
  wrapper: css({
    display: 'flex',
    width: '150px',
    float: 'left',
  }),
  container: css({
    padding: '4px 0',
  }),
  label: css({
    flexBasis: '100px',
  }),
  select: css({
    flexGrow: 4,
    minWidth: '100px',
  }),
  detail: css({
    backgroundColor: 'transparent',
    borderRadius: '5px',
    textAlign: 'center',
    marginLeft: '5px',
  }),
  detailButton: css({
    padding: '4px',
    color: productColor.primary,
    fontSize: '12px'
  }),
  selectDay: css({
    minWidth: '100px',
    width: '170px',
  }),
  globalSearch: css({
    marginLeft: '30px',
    marginBottom: '10px'
  }),
  input: css({
    maxWidth: '600px',
    padding: '30px',
    marginBottom: '30px',
  }),
  backgroundWhite: css({
    backgroundColor: '#fff'
  }),
  table: css({
    color: '#666666'
  }, css`
    table.table-bordered tr td,
    table.table-bordered tr th{
      border:1px solid #dcdcdc;
      text-align:center
    } 
  `),
  customStyle: css({
    display: 'flex',
    justifyContent: ((isSafari && isTablet) || isIPad13) ? 'flex-start' : 'flex-end',
    paddingRight: ((isSafari && isTablet) || isIPad13) ? '10px' : '30px',
    marginBottom: ((isSafari && isTablet) || isIPad13) ? '0px' : '-55px'
  }, css`
    button{
      width:auto;
      margin-left:15px
    }
    button:hover{
      background:transparent
    }
    button svg{
      width:20px !important;
      height:20px !important;
    }
  `),
  note: css({
    paddingLeft: '5px',
    fontSize: '14px',
    color: '#666666',
    position: 'relative'
  }),
  modal: css({
    padding: "0px 0px 16px",
    margin: "0px",
    fontSize: "14px",
    textAlign: "center",
    color: "rgb(102, 102, 102)",
  })
};

export interface DataDetail {
  staffCode: string,
  staffName: string,
  transferDayNumb: string
}

const AcquisitionStatusForm: React.FC<{ orgTreesOptions: any }> = ({
  orgTreesOptions,
}) => {
  const {
    paidHolidayDigestedtHistoryList,
    callGetAcquisitionStatusDetail,
    orgCode,
    setOrgCode,
    searchDate,
    setSearchDate,
    modalOpen,
    setModalOpen,
    closeModal,
    detailItems,
    setOrgCodeName,
    orgCodeName,
    modalOpenDownload,
    setModalOpenDownload
  } = useAcquisitionStatusDomainForm();

  const {
    downloadHolidayManagementAcquisitionStatus, blocking, downloadPaidAttendHolidayManagement
  } = useDownloadHolidayManagementAcquisitionStatus(
    orgCode,
    searchDate,
    orgCodeName,
    setModalOpenDownload
  );

  //
  const [dataDetail, setDataDetail] = useState<DataDetail>({
    staffCode: '',
    staffName: '',
    transferDayNumb: '',
  });

  // handlePaidHolidayStatusDetail
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleTransferHolidayStatusDetail = async (data: any) => {
    
    setDataDetail(data);
    callGetAcquisitionStatusDetail(data.staffCode);
    setModalOpen(true);
  };

  //
  const columns: Array<Column<PaidHolidayDigestedtHistoryDomain>> = React.useMemo(() => [
    {
      Header: () => 'スタッフコード',
      id: 'staffCode',
      accessor: 'staffCode',
      Cell: (cell: {
        row: { isExpanded: boolean, original: PaidHolidayDigestedtHistoryDomain },
        data: Array<PaidHolidayDigestedtHistoryDomain>
      }) => (
          <FlexBox>
            <TextTooltip
              text={cell.row.original.staffCode}
              textDis={(
                <span>{cell.row.original.staffCode}</span>
              )}
              customCss={css({
                textOverflow: 'ellipsis',
                overflow: 'hidden',
                maxWidth: '200px',
                whiteSpace: 'nowrap',
                display: 'inline-block',
                margin: '0px auto',
              })}
              />
            {/* <div css={css(styles.detail)}>
              <ClickableIconButton
                onClick={() => handleTransferHolidayStatusDetail(cell.row.original)}
                additionalCss={styles.detailButton}
              >
                詳細
            </ClickableIconButton>
            </div> */}
            <IconLabelButton
              onClick={() => handleTransferHolidayStatusDetail(cell.row.original)}
              text="詳細"
              isIcon={false}
              textAlign={"center"}
            />
          </FlexBox>
        ),
    },
    {
      Header: 'スタッフ名',
      accessor: 'staffName',
    },
    {
      Header: '合計',
      accessor: 'digestion',
    },
  ], [handleTransferHolidayStatusDetail]);

  //

  useEffect(() => {
    let str = sessionStorage.getItem('loginUser.orgCode') + " " + sessionStorage.getItem('loginUser.orgName'); 
    let orgCodeFilter = orgTreesOptions.filter((option: any) => {
      if(option.value === orgCode){
        return true;
      }
    }); 
    if(orgCodeFilter[0] !== '' && orgCodeFilter[0] !== undefined){
      setOrgCodeName(orgCodeFilter[0].label);
    }else{
      setOrgCodeName(str);
    }
  },[orgCode]);
 
  return (
    <BlockUI blocking={blocking}>
      <Accordion text="取得状況" callBack={() => { }}>
        <div css={styles.backgroundWhite}>
          {/* <FormContentFilter> */}
          <FormPadding customStyle={css({ paddingTop:'16px',paddingLeft:'10px', paddingRight:'10px', maxWidth:'580px'})}>
          <div css={styles.container}>
              <FlexBox>
                <div css={styles.label}>
                  <FormLabel
                    label="対象期間"
                  />
                </div>
                <div css={styles.selectDay}>
                  {/* <CalendarForm required={true} label="" date={new Date(searchDate)} dateFormat='YYYY年MM月DD日' changeDate={(date: Date) => setSearchDate(date)} /> */}
                  <Calendar 
                  date={new Date(searchDate)}
                  setDate={(date) => {
                    if(date){
                      setSearchDate(date)
                    }
                  }}
                  />
                </div>
                <div css={styles.note}>から過去1年間</div>
              </FlexBox>
            </div>
          </FormPadding>
          <FormPadding customStyle={css({ paddingLeft:'10px', paddingRight:'10px', maxWidth:'580px'})}>
          <SelectForm
              label="組織"
              name="orgCode003"
              value={String(orgCode)}
              setValue={(val: string) => {
                setOrgCode(val);
              }}
              options={orgTreesOptions}
            />
          </FormPadding> 
          {/* </FormContentFilter> */}
          <div
            css={css`
              table{
                table-layout: auto;
              }
              table th:nth-of-type(1) {
                width: 100px;
              }
              table td button{
                text-align:center;
              }
              table th:nth-of-type(2) {
                width: 200px;
              }
              table th:nth-of-type(3) {
                width: 160px;
              }
              table td:nth-of-type(3) {
                text-align: center;
            `}
          >
            <FormSubmitArea customStyle={styles.customStyle}>
              <IconLabelButton onClick={() => downloadHolidayManagementAcquisitionStatus()} iconType="download" text="ダウンロード" />
              <IconLabelButton onClick={() => {
                if(!modalOpenDownload){
                  setModalOpenDownload(true);
                  return false;
                }
                }} iconType="download" text="有給管理簿" />

              {/* <IconLabelButton onClick={() => downloadHolidayManagementAcquisitionStatus(true)} iconType="download" text="全組織ダウンロード" /> */}
            </FormSubmitArea>
            <div className="table-bordered" style={{ overflowX: 'auto', whiteSpace: 'nowrap', marginTop: '10px', padding:'0 10px 10px' }}>
              <DataTable
                classNameParrant="border-left-right"
                className="table-no-border-left-right" 
                columns={columns}
                data={paidHolidayDigestedtHistoryList}
                isGlobalFilter={true}
                // globalSearchStyle={styles.globalSearch}
              />
            </div>
          </div>
          <Modal
            open={modalOpenDownload}
            closeHandler={() => setModalOpenDownload(!modalOpenDownload)}
            title="確認メッセージ"
            submitText="ダウンロード"
            onSubmit={() => {
              downloadPaidAttendHolidayManagement();
            }}
            closeText={'キャンセル'}
          >
            <p css={styles.modal}>有給付与日が{ moment(searchDate, 'YYYY-MM-DD HH:mm:ss').subtract(1, 'years').add(1,'days').format('YYYY年MM月DD日') + '〜' + moment(searchDate, 'YYYY-MM-DD HH:mm:ss').format('YYYY年MM月DD日')}のデータを出力します。</p>
          </Modal>
          {/* Form Detail */}
          <Modal
            open={modalOpen}
            closeHandler={closeModal}
            title="取得状況詳細"
            submitText=""
            onSubmit={() => { }}
            closeText={'閉じる'}
          > 
            <div style={{ width: '350px', margin: '0 auto', fontSize: '14px' }} css={styles.table}>
              <VerticalLabelTextLayout
                label="スタッフコード"
                variable={dataDetail.staffCode}
              />
              <VerticalLabelTextLayout
                label="スタッフ名"
                variable={dataDetail.staffName}
              />

              <VerticalLabelTextLayout
                label="期間"
                variable={`${moment(detailItems.fromDate).format('YYYY年MM月DD日')}～${moment(detailItems.toDate).format('YYYY年MM月DD日')}`}
              />

              <table className="table-bordered" style={{ width: '100%' }}>
                <thead>
                  <tr>
                    <th>日付</th>
                    <th>消化日数</th>
                  </tr>
                </thead>
                <tbody>
                  {detailItems.paidHolidayDigestionDetailList && detailItems.paidHolidayDigestionDetailList.map((item: any) => (
                    <tr>
                      <td>
                        {moment(item.digestedDate).format('YYYY年MM月DD日')}
                      </td>
                      <td>
                        {item.digestedNum}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Modal>
        </div>
      </Accordion>
    </BlockUI>
  );
};
export default AcquisitionStatusForm;
